import React from 'react'
import './AboutUs.css'

const AboutUs = () => {
  return (
    <div className='about-page'>

      <div className='about-hero'>
        <h1>Our Story</h1>
        <p>Born from a desire to bring quality pet nutrition to South African pets, ArrAndArr is more than just a store — it's a mission to care for your furry family.</p>
      </div>

      <div className='about-section'>
        <div className='about-section-text'>
          <h2>The Beginning</h2>
          <p>Our founder grew up in a family where community and your connection with those around you is central to everyday life.</p>
          <p>Through caring for animals he learnt responsibility, patience and love.</p>
        </div>
        <div className='about-section-visual'>
          <div className='about-placeholder'>
            &#128062;
            <span>Pets &amp; Nutrition</span>
          </div>
        </div>
      </div>

      <div className='about-section'>
        <div className='about-section-text'>
          <h2>A Mission for Change</h2>
          <p>Every product we stock is chosen not just for quality, but for the health and wellbeing of your pets. We believe that proper nutrition is the foundation of a happy, healthy pet.</p>
        </div>
        <div className='about-section-visual'>
          <div className='about-placeholder'>
            &#127758;
            <span>Community First</span>
          </div>
        </div>
      </div>

      <div className='about-section'>
        <div className='about-section-text'>
          <h2>Looking Forward</h2>
          <p>We are still small, but we dream big. Every customer who walks through our doors — physical or digital — becomes part of a movement to bring quality pet nutrition to South Africa.</p>
          <p>Regardless of what you are here for, you are helping us build a better community of tomorrow.</p>
          <p>Thank you for being part of our collective story.</p>
        </div>
        <div className='about-section-visual'>
          <div className='about-placeholder'>
            &#127775;
            <span>Building Together</span>
          </div>
        </div>
      </div>

      <div className='about-mission'>
        <h2>What We Stand For</h2>
        <div className='about-values'>
          <div className='about-value-card'>
            <h3>Community</h3>
            <p>We exist to serve and strengthen our local community.</p>
          </div>
          <div className='about-value-card'>
            <h3>Accessibility</h3>
            <p>Every pet deserves access to quality nutrition, regardless of their circumstances.</p>
          </div>
          <div className='about-value-card'>
            <h3>Quality</h3>
            <p>We carefully curate products that bring lasting health and real nutritional value to your pet's life.</p>
          </div>
        </div>
      </div>

    </div>
  )
}

export default AboutUs
